@if (scanning) {
  <!-- Scanner Container -->
  <div class="scanner-container">
    <!-- Header -->
    <div class="scanner-header">
      <button class="close-button" (click)="toggleScan()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h1 class="scanner-title">Scan Barcode</h1>
      <div class="header-spacer"></div>
    </div>
    <!-- Camera View -->
    <div class="camera-container">
      <video #video class="camera-video" autoplay playsinline muted></video>

      <!-- Scanning Overlay -->
      <div class="scanning-overlay">
        <!-- Dark overlay -->
        <div class="dark-overlay"></div>

        <!-- Scanning frame -->
        <div class="scanning-frame-container">
          <div class="scanning-frame">
            <!-- Corner frames -->
            <div class="corner-frame top-left">
              <div class="corner-horizontal"></div>
              <div class="corner-vertical"></div>
            </div>
            <div class="corner-frame top-right">
              <div class="corner-horizontal"></div>
              <div class="corner-vertical"></div>
            </div>
            <div class="corner-frame bottom-left">
              <div class="corner-horizontal"></div>
              <div class="corner-vertical"></div>
            </div>
            <div class="corner-frame bottom-right">
              <div class="corner-horizontal"></div>
              <div class="corner-vertical"></div>
            </div>
          </div>
        </div>

        <!-- Instruction text -->
        <div class="instruction-text">
          <p>Hold steady and align barcode within the frame</p>
        </div>
      </div>
    </div>
  </div>
}
@if (!scanning) {
  <button class="scan-butn custom-btn" (click)="toggleScan()">
  </button>
}
